<template>
	<v-container fluid>
		<v-row>
			<v-col>
				<span class="headline">
					Заявки на расходы
				</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="pa-0">
				<a-data-table
					ref="table"
					:headers="computedHeaders"
					api-path="pr/get_list"
					:api-parameters="{
						showAll: showAll
					}"
					disable-sort
					row-cursor-pointer
					:initial="{
						search: $route.params.search,
						filters: $route.params.filters
					}"
					@click:row="clickRow"
					@load="updateCounter"
					class="pt-2 pb-5"
				>
					<template v-slot:search-append-right>
						<v-menu
							v-model="dropdownMenu"
							:close-on-content-click="false"
							bottom left
						>
							<template v-slot:activator="{ on }">
								<v-btn
									icon
									v-on="on"
									class="mt-1 ml-2"
								>
									<v-icon>more_vert</v-icon>
								</v-btn>
							</template>

							<v-list class="d-print-none">
								<v-list-item @click="newPr">
									<v-list-item-icon>
										<v-icon>add</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Новая заявка
									</v-list-item-title>
								</v-list-item>
								<v-list-item>
									<v-switch
										v-model="showAll"
										dense
									>
										<template v-slot:label>
											<span class="pl-2">
												Показать все
											</span>
										</template>
									</v-switch>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>

					<template v-slot:item.id="{ item }">
						<v-chip
							small
							label
							color="primary"
							:to="{ name: 'PrEntry', params: { id : item.id } }"
						>
							<v-icon small left>shopping_basket</v-icon>
							{{ item.id }}
						</v-chip>
					</template>
					<template v-slot:item.createdDate="{ item }">
						{{ item.createdDateFormatted }}
					</template>
					<template v-slot:item.authorName="{ item }">
						<span class="text-no-wrap">
							{{ item.authorName }}
						</span>
					</template>
					<template v-slot:item.type="{ item }">
						{{ typeName(item.type) }}
					</template>
					<template v-slot:item.dcName="{ item }">
						<v-tooltip left open-delay="500">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									{{ item.dcName }}
								</span>
							</template>
							{{ item.dcNameTooltip }}
						</v-tooltip>
					</template>
					<template v-slot:item.status="{ item }">
						<v-tooltip left open-delay="500" v-if="item.statusName !== item.statusNameShort">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									{{ item.statusNameShort }}
								</span>
							</template>
							{{ item.statusName }}
						</v-tooltip>
						<span v-else>
							{{ item.statusName }}
						</span>
					</template>
					<template v-slot:item.sumNet="{ item }">
						<div class="text-no-wrap" style="min-width: 60px;">
							{{ item.sumText }}
						</div>
					</template>
					<template v-slot:item.stamps="{ item }">
						<div class="text-no-wrap">
							<v-chip
								small label link
								v-if="item.stamps.approved"
								color="blue"
								text-color="white"
								class="mr-1 mt-1"
							>
								Согласовано
							</v-chip>

							<v-chip
								small label link
								v-if="item.stamps.prepaid"
								color="green"
								text-color="white"
								class="mr-1 mt-1"
							>
								Предоплачено
							</v-chip>

							<v-chip
								small label link
								v-if="item.stamps.paid"
								color="green"
								text-color="white"
								class="mr-1 mt-1"
							>
								Оплачено
							</v-chip>

							<v-chip
								small label link
								v-if="item.stamps.urgent"
								color="orange"
								text-color="white"
								class="mr-1 mt-1"
							>
								Срочно
							</v-chip>

							<v-chip
								small label link
								v-if="item.stamps.charged"
								color="green"
								text-color="white"
								class="mr-1 mt-1"
							>
								Начислено
							</v-chip>

							<v-chip
								small label link
								v-if="item.stamps.closed"
								color="grey"
								text-color="white"
								class="mr-1 mt-1"
							>
								Закрыто
							</v-chip>

							<v-chip
								small label link
								v-if="item.stamps.rejected"
								color="red"
								text-color="white"
								class="mr-1 mt-1"
							>
								Закрыто
							</v-chip>
							<v-chip
								small label link
								v-if="item.newComments"
								color="blue-grey"
								text-color="white"
								class="mr-1 mt-1"
								@click="checkNewComments(item)"
							>
								...
							</v-chip>
						</div>
					</template>

				</a-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import aDataTable from '../base/ADataTable.vue'
import { mixinLists } from './lists.js'
import _ from 'lodash'

export default {
	mixins: [
		mixinLists,
	],
	components: {
		aDataTable
	},
	data: () => ({
		headers: [
			{
				text: '№',
				value: 'id',
				align: 'center',
				filterable: true,
				filterType: 'number',
			},
			{
				text: 'Дата',
				value: 'createdDate',
				align: 'center',
				filterable: true,
				filterType: 'date',
			},
			{
				text: 'Отель',
				value: 'hotelCode',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Автор',
				value: 'authorName',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Заголовок',
				value: 'title',
				align: 'center',
				filterable: false,
				filterType: 'text',
			},
			{
				text: 'Тип',
				value: 'type',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Отдел',
				value: 'dcName',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Сумма, ₽',
				value: 'sumNet',
				align: 'center',
				filterable: true,
				filterType: 'number',
			},
			{
				text: 'Этап',
				value: 'status',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Отметки',
				value: 'stamps',
				align: 'center',
				filterable: false,
			},
		],
		showAll: false,
		dropdownMenu: false,
		timer: 0,
		scroll: false,
		updateInterval: 300000,	// 5 минут
	}),
	computed: {
		computedHeaders() {
			if (this.$vuetify.breakpoint.xsOnly) {
				return this.headers.filter(h => {
					return h.value == 'title'
						|| h.value == 'createdDate'
				})
			}
			else {
				return this.headers
			}
		}
	},
	methods: {
		checkNewComments(row) {
			this.scroll = true
			this.clickRow(row)
		},
		clickRow(row) {
			this.$router.push({
				name: 'PrEntry',
				params: {
					id: row.id,
					filters: this.$refs.table.filters,
					search: this.$refs.table.search,
					showAll: this.showAll,
					scroll: this.scroll
				}
			})
		},
		dcName(dc) {
			return this.lists.type.find(t => t.value == dc).text
		},
		newPr() {
			this.$router.push('pr/new')
		},
		typeName(type) {
			return this.lists.type.find(t => t.value == type).text
		},
		updateCounter() {
			this.$store.dispatch('loadMenuCounters')
		},
	},
	created() {
		if (this.$route.params.showAll !== undefined) {
			this.showAll = this.$route.params.showAll
		}
	},
	mounted() {
		this.timer = setInterval(() => {
			// console.log('interval function')
			if (!document.hidden) {
				this.$refs.table.clearAndLoad()
			}
		}, this.updateInterval)

		// console.log(window.onfocus)

		window.onfocus = () => {
			// console.log('onfocus')
			this.$refs.table.clearAndLoad()
		}
	},
	destroyed() {
		clearInterval(this.timer)
		window.onfocus = null
	},
}
</script>

<style>
</style>
